import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col, Flex, Form, Row } from 'antd';

// components
import FormElement from 'components/formElement/formElement';
import ComponentHeader from 'components/componentHeader/componentHeader';
import PhoneInputComponent, { PhoneInputReturn } from 'components/phoneInput/phoneInput';

// services
import { checkPhoneValidation } from 'utils/validators/phone';

const ProfileDataComponent: FunctionComponent = () => {
	const { t } = useTranslation();

	const [profileForm] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);

	type FieldType = {
		name: string;
		email: string;
		phone: string;
	};

	const onChangePhone = ({ dialCode, number }: PhoneInputReturn) => {
		profileForm.setFieldsValue({
			phone: dialCode + number,
		});
	};

	const validatePhone = (_: any, value: any) => {
		// if (checkPhoneValidation(value)) {
		// 	return Promise.resolve();
		// } else if (value) return Promise.reject(new Error(t('COMMON.PHONE_INVALID')));
		// else return Promise.reject();
	};

	return (
		<>
			<Card>
				<Row>
					<Col span={24} lg={8}>
						<ComponentHeader title={t('PROFILE.SYSTEM_ADMIN_INF')} subtitle={t('PROFILE.UPDATE_YOUR_PERSONAL_DETAILS')} />
					</Col>
					<Col span={24} lg={10}>
						<Form form={profileForm}>
							<Row gutter={[16, 16]}>
								<Col span={24} lg={12}>
									<FormElement name="org_name" type="text" label={t('PROFILE.ORGANIZATION_NAME')} />
								</Col>

								<Col span={24} lg={12}>
									<FormElement name="org_id" type="text" label={t('PROFILE.ORGANIZATION_ID')} />
								</Col>

								<Col span={24}>
									<FormElement fullWidth name="admin_email" type="email" label={t('PROFILE.SYSTEM_ADMIN_EMAIL')} />
								</Col>

								<Col span={24}>
									<FormElement fullWidth name="admin_id" type="number" label={t('PROFILE.SYSTEM_ADMIN_EMAIL')} />
								</Col>

								<Col span={24}>
									<Form.Item style={{ marginTop: 20, maxWidth: 'unset' }}>
										<Button block type="primary" htmlType="submit" loading={isLoading}>
											{t('COMMON.UPDATE')}
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Card>
		</>
	);
};

export default ProfileDataComponent;
